const PhoneCircleIcon = () => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="12.1563" cy="12.1563" r="12.1563" fill="white" />
      <path
        d="M14.4837 19.2358C14.0277 19.0969 13.5786 18.9009 13.1365 18.6479L13.0877 18.6197C11.5668 17.7338 10.1277 16.1715 8.77045 13.9326C8.48548 13.4625 8.22945 13.0044 8.00237 12.5582C6.82442 10.2438 6.42541 8.25132 6.80524 6.58106C6.98116 5.8075 7.53575 5.18758 8.28352 4.91215L8.4921 4.84572L9.34845 4.61422C10.0905 4.41363 10.8897 4.74548 11.2884 5.39743L11.3731 5.55347L12.0948 7.06416C12.3078 7.51003 12.3068 8.0045 12.1159 8.42097C12.0779 8.50393 12.0324 8.5838 11.9795 8.65957C11.9439 8.71058 11.9049 8.75973 11.8627 8.80673L11.7403 8.92862L10.3649 10.1542C10.4695 11.0205 10.7495 11.8542 11.2048 12.6552C11.5951 13.3417 12.0625 13.9132 12.6069 14.3697L12.8856 14.5883L14.8009 14.0125C15.4318 13.8228 16.1279 14.0234 16.5779 14.5097L16.6943 14.6494L17.7024 15.9946C18.1752 16.6255 18.1454 17.4657 17.651 18.0211L17.538 18.1356L16.8969 18.7214C16.2614 19.3021 15.3433 19.4978 14.4837 19.2358Z"
        fill="#002133"
      />
    </svg>
  );
};

export default PhoneCircleIcon;
